import React from 'react';
import NoSSR from 'react-no-ssr';
import MediaQuery from 'react-responsive';

import { trans } from '@spotahome/soyuz/client';
import { Heading } from '@spotahome/ui-library';

import {
  MQ_TABLET_MIN_WIDTH,
  MQ_MOBILE_MAX_WIDTH
} from '../../../common/constants';

import CardsImagesDefault from './CardsImagesDefault';
import CardsImagesMobile from './CardsImagesMobile';

import './CardsImages.scss';

const CardsImages = () => (
  <div className="wrapper">
    <Heading
      size="large"
      text={trans('home-checker.mission.title')}
      className="mb-xl"
    />
    <p className="cards-images__description">
      {trans('home-checker.mission.description')}
    </p>

    <NoSSR>
      <MediaQuery minWidth={MQ_TABLET_MIN_WIDTH}>
        <CardsImagesDefault />
      </MediaQuery>
    </NoSSR>

    <NoSSR>
      <MediaQuery maxWidth={MQ_MOBILE_MAX_WIDTH}>
        <CardsImagesMobile />
      </MediaQuery>
    </NoSSR>
  </div>
);

export default CardsImages;
